import React from "react";
import Editor from "./MarkdownEditor/Editor";

const MarkdownEditor = () => {
  return (
    <div>
      <Editor />
    </div>
  );
}

export default MarkdownEditor;
